import { instance } from "api/apiBase";
import type {
  BoomHelpFeedbackReason,
  BoomHelpHandoffReason,
  BoomHelpHandoffResponse,
  BoomHelpMessage,
  BoomHelpRating,
  SendBoomHelpMessageResponse
} from "api/boom-help/types";

export const boomHelpApi = {
  sendMessage: async (body: {
    conversation_id?: number;
    content: string;
    page: string;
    client_message_id: string;
  }): Promise<SendBoomHelpMessageResponse> => {
    const { data } = await instance.post<SendBoomHelpMessageResponse>(
      "/portal/v1/boom_help/messages",
      body
    );
    return data;
  },

  getMessage: async ({
    conversationId,
    messageId
  }: {
    conversationId: number;
    messageId: number;
  }): Promise<BoomHelpMessage> => {
    const { data } = await instance.get<BoomHelpMessage>(
      `/portal/v1/boom_help/conversations/${conversationId}/messages/${messageId}`
    );
    return data;
  },

  rateMessage: async ({
    messageId,
    rating,
    reason,
    comment
  }: {
    messageId: number;
    rating: BoomHelpRating;
    reason?: BoomHelpFeedbackReason;
    comment?: string;
  }) => {
    const { data } = await instance.post(
      `/portal/v1/boom_help/messages/${messageId}/feedback`,
      { rating, reason, comment }
    );
    return data;
  },

  handOff: async ({
    conversationId,
    reason
  }: {
    conversationId: number;
    reason: BoomHelpHandoffReason;
  }): Promise<BoomHelpHandoffResponse> => {
    const { data } = await instance.post<BoomHelpHandoffResponse>(
      `/portal/v1/boom_help/conversations/${conversationId}/handoff`,
      { reason }
    );
    return data;
  }
};
